import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saInterCuInterFreqHandoutCellChartConfig } from '../cellChartConfigs';

interface InterCuInterFreqHandoutSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuInterFreqHandoutSaCell: React.FC<InterCuInterFreqHandoutSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saInterCuInterFreqHandoutCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default InterCuInterFreqHandoutSaCell;
